import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Typography, Tabs, Tab, Box, Chip } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchyIds: any;
        selectedHierarchies: any;
    };
}

export interface IState {
    curation_stats: any;
    show: boolean;
    selectedBarcode: any;
    selectedProfiler: any;
    selectedRows: any[];
    toggleCleared: boolean;

    children?: React.ReactNode;
    pendingCustomerLeadsCount: number;
    unreadTicketMessagesCount: number;

    urls: any;
    current_path: string;
    hierarchies: any;
    internalHierarchyIds: any[];
}

class NeighbourhoodHeader extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        let current_path: any = this.props.location.pathname;
        current_path = (current_path) ? current_path.split('/') : [];
        if (current_path.length > 3) {
            current_path = current_path.slice(0, 3);
            current_path = current_path.join('/');
        } else {
            current_path = current_path.join('/');
        }
        this.state = {
            curation_stats: {
                "barcodes_count": 0,
                "assigned_barcodes_count": 0,
                "inprogress_barcodes_count": 0,
                "curated_barcodes_count": 0
            },
            show: false,
            selectedBarcode: {},
            selectedProfiler: "",
            selectedRows: [],
            toggleCleared: false,
            pendingCustomerLeadsCount: 0,
            unreadTicketMessagesCount: 0,
            urls: [
                '/neighbourhood/customers',
                '/neighbourhood/tickets',
                '/neighbourhood/inactive-registrations',
                '/neighbourhood/community-list',
                '/neighbourhood/pause-pickups'
            ],
            current_path: current_path,
            hierarchies: [],
            internalHierarchyIds: [1, 2, 3, 4, 5, 6]
        }
    }
    public componentDidMount(): void {
        // axios.get(`curation-stats`).then(response => {
        //     this.setState({ curation_stats: response.data.data })
        // });
        this.fetchUnreadCounts();
        this.fetchAccessibleHierarchiesList();
    }

    public fetchUnreadCounts() {
        axios.get(`getUnreadCounts`, {
            params: { hierarchies: this.props.user.selectedHierarchyIds },
        }).then((response) => {
            if (response.data.success) {
                let data = response.data.data;
                this.setState({
                    pendingCustomerLeadsCount: data.pending_leads,
                    unreadTicketMessagesCount: data.unread_ticket_messages
                });
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    public fetchAccessibleHierarchiesList() {
        axios.get(`accessibleHierarchiesList`).then(response => {
            let hierarchy_ids: any = [];
            if (response.data.success) {
                response.data.data.map((hierarchy: any) => {
                    hierarchy_ids.push(hierarchy.id);
                });
            }
            this.setState({ hierarchies: hierarchy_ids }, () => {
                let urls = this.state.urls;
                if (this.state.hierarchies.some((item: any) => this.state.internalHierarchyIds.includes(item))) {
                    urls.splice(1, 0, '/neighbourhood/customer-leads');
                }
                this.setState({ urls });
            });
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const handleChange = (event: React.SyntheticEvent, newValue: number) => {
            this.props.history.push(this.state.urls[newValue]);
        };
        return (
            <div>
                <Typography variant="h4" className='page-title'>{t("Neighbourhood")}</Typography>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={this.state.urls.indexOf(this.state.current_path)} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Customers" />
                        {
                            this.state.hierarchies.some((item: any) => this.state.internalHierarchyIds.includes(item)) &&
                            <Tab label="Customer Leads" icon={<Chip size="small" color="warning" label={this.state.pendingCustomerLeadsCount} />} iconPosition="end" />
                        }
                        <Tab label="Tickets" icon={<Chip size="small" color="warning" label={this.state.unreadTicketMessagesCount} />} iconPosition="end" />
                        <Tab label="Inactive Registrations" />
                        <Tab label="Communities" />
                        <Tab label="Pause Pickups" />
                    </Tabs>
                </Box>
            </div>
        )
    }
}

export default withRouter(withTranslation()(NeighbourhoodHeader))